export default __webpack_public_path__ + "static/media/no_image-sm.33821032.png";